import React from 'react';
import { connect } from 'react-redux';
import './ReloginPopup.scss';
import BaseComponent from '../../baseClasses/BaseComponent';

import Analytics from '../../helpers/analytics/analytics';
import dataModel from '../../models/DataModel';
import SessionManager from '../../helpers/session/SessionManager';
import CacheUtil from '../../helpers/session/CacheUtil';
import Metadata from '../../helpers/metadata/Metadata';
import connectivityHeartbeat from '../../helpers/ConnectivityHeartbeat';
import Input from '../Input';

export class ReloginPopup extends BaseComponent {
  constructor(props) {
    super(props);
      
    this.state = { 
      email: this.emailAddress, 
      password: '', 
      edited: false,
      errorMessage: null,
    };
    let opts = {};
    opts.currentRole = props.currentUser ? props.currentUser.role : null;
    this.analytics = new Analytics(opts);
    this.stopPrefill = true;
  }

  componentDidMount() {
    if (this.passwordElement) {
      this.passwordElement.focus();
    }
  }

  get emailAddress() {
    let email = '';
    const emailParts = this.props.currentUser ? this.props.currentUser.email.split('@') : [];
    if (emailParts.length > 1) {
      if (emailParts[0].length < 8) {
        email = emailParts[0].substr(Math.min(4, emailParts[0].length), Math.max(0, emailParts[0].length - 4));
        email = '****' + email;
        email += '@' + emailParts[1];        
      }
      else {
        const eLength = emailParts[0].length;
        email = emailParts[0].substr(4, Math.max(0, emailParts[0].length - 4));
        while (email.length < eLength) {
          email = '*' + email;
        }
        email += '@' + emailParts[1];        
      }
    }
    return email;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.currentUser != this.props.currentUser) {
      this.setState ({ email: this.emailAddress });
    }  
  }

  handleRelogin() {
    const email = this.state.emailChanged ? this.state.email : this.props.currentUser.email;
    SessionManager.login(email, this.state.password, true)
      .then(loggedInUser => {
        CacheUtil.reloadSpaIfNeeded();
        Metadata.start();
        connectivityHeartbeat.start(this.props.dataModel);
      })
      .catch(loginError => {
        if (this.passwordElement) {
          this.passwordElement.focus();
        }
        this.setState({ errorMessage: loginError.message });
      });
  }

  handlePasswordChange(e) {
    this.setState({ password: e.target.value, edited: e.target.value ? true : false, errorMessage: null });
  }

  handleEMailChange(e) {
    this.setState({ email: e.target.value, emailChanged: true, edited: e.target.value ? true: false });
  }

  handleKeyDown(e) {
    if (this.state.edited && (e.keyCode == 13 || e.keyCode == 40)) {
      e.stopPropagation();
      this.handleRelogin();
    }
    else if (e.keyCode == 27) {
      e.stopPropagation();
      this.handleClose();
    }
  }

  handleClose() {
    this.props.dataModel.needsPartialLogin = false;
    this.props.dataModel.setPassthroughUri(null);
    this.props.dataModel.hideGlobalModal();
    SessionManager.logoff(true);
  }

  render(){
    let brandColor = '#CD030A';
    if (this.props.currentCompany) {
      brandColor = this.props.currentCompany.accent_color;
    }

    let loginError = null;
    if (this.state.errorMessage) {
      loginError = <div className="login-error">{this.state.errorMessage}</div>;
    }

    const popUp = (
      <div className='relogin-modal-overlay' id='relogin-modal-overlay' onKeyDown={this.handleKeyDown}>
        <div className='relogin-modal' id='modal'>
          <div className='relogin-modal-header' style={{ backgroundColor: brandColor }}>
            <div className="relogin-modal-title"> Session Timeout <span className="close-button" onClick={this.handleClose}> &times; </span> </div>
          </div>
          <div className='relogin-modal-body'>
            <div className='title-text'>
              <div className='text'>
                Sorry your session has expired. Please enter your password to login.
              </div>
              {loginError}
            </div>

            <div className='login-form'>

              <div className="input-field">
                <div className="input-label">
                  EMAIL ADDRESS
                </div>
                  <Input className="input-input" type="email" value={this.state.email} onChange={this.handleEMailChange} />
              </div>

              <div className="input-field">
                <div className="input-label">
                  PASSWORD
                </div>
                <Input className="input-input" type="password" value={this.state.password}
                  onChange={this.handlePasswordChange} ref={element => { this.passwordElement = element; }} />
              </div>
            </div>
          </div>
          <div className='relogin-modal-footer'>
            <div className='footer-center'>
              <div className={'relogin-modal-button'} id='continue-button' onClick={this.handleRelogin}
                style={{ backgroundColor: !this.state.edited ? '#e0e0e0' : brandColor, border: '1px solid ' + (!this.state.edited ? '#a0a0a0' : brandColor) }}>
                <div className='text'>Login</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );

    return popUp;
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
    currentUser: state.new_users.currentUser,
    currentCompany: state.new_companies.currentCompany,
    goToHome: state.main.goToHome,
  };
};

export default connect(mapStateToProps)(ReloginPopup);



// WEBPACK FOOTER //
// ./src/components/ReloginPopup/index.js